'use strict';

function getRules() {
    return {
        title:[
            {required: true, message: '不可为空', trigger: 'change,blur'},
        ],
        handlerGroup:[
            {required: true, message: '不可为空', trigger: 'change,blur'},
        ],
        currentHandler:[
            {required: true, message: '不可为空', trigger: 'change,blur'},
        ],
        timeType:[
            {required: true, message: '不可为空', trigger: 'change,blur'},
        ],
        date:[
            {required: true, message: '不可为空', trigger: 'change,blur'},
        ],
        week:[
            {required: true, message: '不可为空', trigger: 'change,blur'},
        ],
        month:[
            {required: true, message: '不可为空', trigger: 'change,blur'},
        ],

        day:[
            {required: true, message: '不可为空', trigger: 'change,blur'},
        ],


    };
}
export {
    getRules
}

